import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SelectQuickPicker from '../../components/common/SelectQuickPicker';
import {
  CONTINUE_TO_CHANGE_FLOOR_PLAN,
  filterFloorPlan,
  preChangeFloorPlan
} from '../../actions/visual';

class SelectQuickFloorPlan extends Component {

  constructor(props) {
    super(props);
    this.state = {
      title: null,
      options: null,
      defaultValue: null
    }
  }

  filterId = 'floor-plan-pick';

  getSelectOption = () => {
    const { filterFloorPlan, visualListId } = this.props;
    let options = [], title = {}, selectIndex = 0


    // visualList.mappingGroups.forEach((element, index) => {
    //   options.push(element.interiorGraph.id);
    //   title[element.interiorGraph.id] = element.interiorGraph.name;
    //   if(parseInt(localStorage.getItem("graphId")) === element.interiorGraph.id) {
    //     selectIndex = index;
    //   }
    // });

    visualListId.mappingGroups.forEach((element, index) => {
      options.push(element.id);
      title[element.id] = element.name;
      if(parseInt(localStorage.getItem("graphId")) === element.id) {
        selectIndex = index;
      }
    });

    filterFloorPlan(options[selectIndex], title[options[selectIndex]]);

    this.setState({
      title: title,
      options: options,
      defaultValue: options[selectIndex]
    })
  }

  componentDidMount() {
    const { visualListId} = this.props;
    if (visualListId) {
      this.getSelectOption();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { status, filterFloorPlan, nextFloorPlanId, selectGraph, visualListId } = this.props;
    if (JSON.stringify(prevProps.visualListId) !== JSON.stringify(visualListId) && visualListId) {
    // if (JSON.stringify(prevProps.visualList) !== JSON.stringify(visualList) && visualList) {
    //   this.getSelectOption();
    // }
      this.getSelectOption();
    } 
    if(prevProps.selectGraph !== selectGraph && selectGraph) {
      // store the current floor plan graph id
      localStorage.setItem("graphId", selectGraph)
    }
    if (status === CONTINUE_TO_CHANGE_FLOOR_PLAN) {
      filterFloorPlan(nextFloorPlanId);
      this.setState({ defaultValue: nextFloorPlanId });
    }
  }

  render() {
    const { preChangeFloorPlan, nextFloorPlanId } = this.props
    const { title, options, defaultValue } = this.state;
    if (title !== null && options.length > 0) {
      return (
        <div className='area-graph-pick'>
          <SelectQuickPicker
              id="floor-plan-toolbar-select-floor-plan"
              filterId={this.filterId}
              title={title}
              options={options}
              defaultValue={defaultValue}
              doActions={preChangeFloorPlan}
              nextFloorPlanId={nextFloorPlanId}>
          </SelectQuickPicker>
        </div>
      )
    } else {
      return (<></>)
    }

  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    visualList: state.visualReducers.visualList,
    selectGraph: state.visualReducers.graphId,
    status: state.visualReducers.status,
    nextFloorPlanId: state.visualReducers.nextFloorPlanId,
    visualListId: state.visualReducers.visualListId,
  }
}

const mapDispatchToProps = {
  filterFloorPlan,
  preChangeFloorPlan
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectQuickFloorPlan))